
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"queryNursesByHospital"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hospital_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryNursesByHospitalNameIndex"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hospital_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hospital_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nurse_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hospital_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"charge_currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_admin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_selectable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_control"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_polls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_tag_based"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tag_labels"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nextToken"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateNurses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateNursesInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNurses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nurse_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hospital_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"charge_currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_admin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_selectable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_control"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_polls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_tag_based"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tag_labels"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":823}};
    doc.loc.source = {"body":"\nquery queryNursesByHospital($hospital_id: String!, $after: String) {\n    queryNursesByHospitalNameIndex(hospital_id: $hospital_id, after: $after) {\n        items {\n            nurse_id\n            full_name\n            phone_number\n            role_title\n            hospital_id\n            charge_currency\n            is_admin\n            is_selectable\n            next_control\n            next_polls\n            next_tag_based\n            tag_labels\n        }\n        nextToken\n    }\n}\n\nmutation updateNurses($input: UpdateNursesInput!) {\n    updateNurses(input: $input) {\n        nurse_id\n        full_name\n        phone_number\n        role_title\n        hospital_id\n        charge_currency\n        is_admin\n        is_selectable\n        next_control\n        next_polls\n        next_tag_based\n        tag_labels\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["queryNursesByHospital"] = oneQuery(doc, "queryNursesByHospital");
        
        module.exports["updateNurses"] = oneQuery(doc, "updateNurses");
        
